import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { finalize } from 'rxjs';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoadingService);
  loader.loading.set(true);
  return next(req).pipe(
    finalize(() => {
      loader.loading.set(false);
    })
  )
};
